// Order status, payment status and payment method are stored as raw values
// ('confirmed', 'unpaid', 'cash'). They are data, not copy — the database keeps
// one spelling for everyone, and only the screen translates it.
//
// Anything not in the locale files falls back to the value with underscores
// turned into spaces, so a new status added server-side still reads sensibly
// instead of rendering a missing key.
import i18n from '../i18n';

const labelFrom = (namespace, value) => {
  const raw = String(value ?? '').trim();
  if (!raw) return '';
  const key = raw.toLowerCase();
  const translated = i18n.t(`${namespace}.${key}`, { defaultValue: '' });
  return translated || raw.replace(/_/g, ' ');
};

export const orderStatusLabel = (value) => labelFrom('orderStatus', value);
export const paymentStatusLabel = (value) => labelFrom('paymentStatus', value);
export const paymentMethodLabel = (value) => labelFrom('paymentMethod', value);
